/** maximum images which user can store in one board */
export const maxPossibleImagesInOneBoard = 30;

/** maximum possible boards which user can create */
export const maxPossibleBoards = 10;
